import React from 'react';
import { CoreWebinar } from './CoreWebinar';
import { SupplementarySeries } from './SupplementarySeries';
import { webinarGroups } from '../../data/webinars';
import { getNextSession } from '../../utils/webinars';
export function WebinarBrowser() {
  const nextSession = getNextSession(webinarGroups);
  const coreGroup = webinarGroups.find(group => group.kind === 'core');
  const supplementaryGroups = webinarGroups.filter(group => group.kind === 'supplementary');
  return <div id="webinars" className="w-full scroll-mt-4" data-id="element-88" data-mp="1qs1jozbk7gk3">
      {coreGroup && <CoreWebinar group={coreGroup} nextSessionId={nextSession?.id} data-id="element-89" data-mp="1qpxhqmx80rmg" />}
      <SupplementarySeries groups={supplementaryGroups} nextSessionId={nextSession?.id} data-id="element-90" data-mp="25fwimxg5uh5m" />
    </div>;
}